import { ReactElement } from 'react';
import style from './OpeningHours.module.scss';

import Stl from '@root/lib/Stl';
const st = (new Stl()).bind(style);

type Props = {
  weekdays: Array<boolean>;
  check_in_start: string;
  check_in_end: string;
  check_out_end: string;
}

export default function LocationDetailOpeningHours(props: Props): ReactElement {
  const weekdayLabels = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  const check_in_start_cleaned = props.check_in_start.slice(0, -3);
  const check_in_end_cleaned = props.check_in_end.slice(0, -3);
  const check_out_end_cleaned = props.check_out_end.slice(0, -3);

  const weekdays = Array.from(props.weekdays);
  // weekdays.push(weekdays.shift());

  return (
    <>
      <ul className={ st`list` }>
        { weekdays.map((weekdayOpen, weekdayIndex) => (
          <li
            key={ weekdayIndex }
            className={ st`row ${ weekdayOpen ? 'open' : 'closed' }` }
          >
            <span className={ st`day` }>{ weekdayLabels[weekdayIndex] }</span>
            <span className={ st`status` }>{ weekdayOpen ? 'Open' : 'Closed' }</span>
          </li>
        )) }
      </ul>
      <div className={ st`box` }>
        <div className={ st`boxRow` }>
          <img className={ st`boxIcon` } src="/images/icons/check-in.svg" alt="Check in clock" />
          <span>Check-in is in between { check_in_start_cleaned } and { check_in_end_cleaned }</span>
        </div>
        <div className={ st`boxRow` }>
          <img className={ st`boxIcon` } src="/images/icons/check-out.svg" alt="Check out clock" />
          <span>Check-out is all day until { check_out_end_cleaned }</span>
        </div>
      </div>
    </>
  );
}
